import React from 'react';

export const PhotoStrip = ({ heading, photos }) => (
  <section className="bg-white py-12 sm:py-16" aria-label={heading}>
    <div className="container mx-auto px-4">
      {heading && (
        <h2 className="mb-8 text-center text-2xl font-bold text-gray-900 sm:text-3xl">{heading}</h2>
      )}
      <div className="grid gap-4 sm:grid-cols-3">
        {photos.map((photo) => (
          <figure key={photo.src} className="overflow-hidden rounded-xl shadow-md">
            <img
              src={photo.src}
              alt={photo.alt}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full object-cover transition-transform duration-300 hover:scale-105"
            />
          </figure>
        ))}
      </div>
      <p className="mt-4 text-center text-xs text-gray-500">Images are illustrative.</p>
    </div>
  </section>
);
